import { inject, Component, input } from "@angular/core";
import { RewardCursor } from "@components/reward-mechanism/reward-cursor";
import { Switch } from "@components/switch/switch";
import { EducationLevelGroup } from "@domain/EducationLevel";
import { AnalyticsService } from "@services/analytics.service";
import { RewardService } from "@services/reward.service";
import { AuthState } from "@states/auth.state";

@Component({
  selector: "app-reward-mechanism",
  template: `
    @let userCurrentCursor = authState.currentUser()?.rewardCursors?.getCurrentCursor();
    @let userLastAvailableCursor = authState.currentUser()?.rewardCursors?.getLastAvailableCursor();
    @let showRewardMechanism = authState.currentUser()?.showRewardMechanism ?? false;

    @if (showRewardMechanism && userCurrentCursor) {
      <app-reward-cursor [rewardCursor]="userCurrentCursor" />
    }

    @if (showVisibilityToggle() && userLastAvailableCursor && !!userCurrentCursor) {
      <div class="reward-mechanism__toggle">
        <app-switch
          id="reward-mechanism__toggle-switch"
          [checked]="!showRewardMechanism"
          label="Masquer le curseur récompense"
          (toggleSwitch)="handleRewardMechanismVisibilitySwitchToggle($event)"
        />
      </div>
    }
  `,
  styles: `
    @use "responsive" as *;
    @use "visuallyhidden" as *;

    .reward-mechanism__toggle {
      position: absolute;
      left: 52px;
      bottom: 39px;
      z-index: 9980;

      @include screenWidth("tablet-only") {
        bottom: 32px;
        width: calc(50vw - 170px);
      }

      @include screenWidth("mobile-only") {
        @include visuallyhidden();
      }
    }
  `,
  imports: [Switch, RewardCursor],
})
export class RewardMechanism {
  protected rewardService = inject(RewardService);
  protected authState = inject(AuthState);
  protected analyticsService = inject(AnalyticsService);

  educationLevelGroup = input.required<EducationLevelGroup | undefined>();
  showVisibilityToggle = input(true);

  protected handleRewardMechanismVisibilitySwitchToggle(value?: boolean) {
    const userCurrentCursor = this.authState.currentUser()!.rewardCursors.getCurrentCursor()!;

    if (value) {
      this.rewardService.hideRewardMechanism();
      this.analyticsService.trackRewardVisibilityToggle(userCurrentCursor, false, this.educationLevelGroup());
    } else {
      this.rewardService.showRewardMechanism();
      this.analyticsService.trackRewardVisibilityToggle(userCurrentCursor, true, this.educationLevelGroup());
    }
  }
}
